<b>Vehicle Status</b>
<hr>
<ngx-charts-pie-chart
  [view]="view"
  [scheme]="colorScheme"
  [results]="dataPie"
  [gradient]="gradient"
  [legend]="showLegend"
  [labels]="showLabels"
  [doughnut]="doughnut"
  >
</ngx-charts-pie-chart>
